let html = `
<svg width="25" height="41" viewBox="0 0 25 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.101807" y="20.6182" width="28.7098" height="5.9619" rx="2.98095" transform="rotate(-45 0.101807 20.6182)" fill="currentColor"/>
    <rect width="28.7098" height="5.9619" rx="2.98095" transform="matrix(0.707107 0.707107 0.707107 -0.707107 0.101807 20.7075)" fill="currentColor"/>
</svg>
`

export default html